/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './driving-distance.stache';

Component.extend({
    tag: 'leaderboard-driving-distance',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            round: {
                type: 'number',
                value: 1,
            },
            player: {
                Type: can.Map,
            },
            stats: {
                get() {
                    let roundInfo = this.attr('round')
                        ? this.attr(
                              `player.roundsInfo.${this.attr('round') -
                                  1}.stats`,
                          )
                        : this.attr('player.overallStats');
                    roundInfo = roundInfo
                        ? roundInfo
                              .filter(
                                  (stat) => stat.name === 'Driving Distance',
                              )
                              .pop() || new can.Map({})
                        : new can.Map({});

                    let stats = {
                        statRank: roundInfo.attr('rank') || 0,

                        playerStat: roundInfo.attr('stat.value') || 0,
                        playerStatInteger:
                            Math.floor(roundInfo.attr('stat.value')) || 0,
                        playerStatFractional:
                            getFractionalPart(roundInfo.attr('stat.value')) ||
                            0,

                        fieldStat: roundInfo.attr('average.value') || 0,
                        fieldStatInteger:
                            Math.floor(roundInfo.attr('average.value')) || 0,
                        fieldStatFractional:
                            getFractionalPart(
                                roundInfo.attr('average.value'),
                            ) || 0,
                    };

                    if (stats.playerStat) {
                        stats.playerStatPercent = getPercent(
                            [stats.playerStat, stats.fieldStat],
                            stats.playerStat,
                        );
                    } else {
                        stats.playerStatPercent = 0;
                    }

                    if (stats.fieldStat) {
                        stats.fieldStatPercent = getPercent(
                            [stats.playerStat, stats.fieldStat],
                            stats.fieldStat,
                        );
                    } else {
                        stats.fieldStatPercent = 0;
                    }

                    return stats;
                },
            },
        },
    },
    events: {},
});

function getFractionalPart(number, fractionalLength = 2) {
    return parseInt(
        (number % 1).toFixed(fractionalLength).substring(fractionalLength),
    );
}
function getPercent(collection, item) {
    const max = Math.max.apply(null, collection);
    if (max) {
        return Math.round((100 * item) / max);
    }
    return 100;
}
